import { Component, OnInit, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { AccountDefiningModel, DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConsts } from 'src/app/common/app-consts';
import { PurchaseDetailModel, SavePurchaseMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { E_G_EPSStatusType } from 'src/app/viewmodels/g-purchase/E_G_EPSStatusType';
import { SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';

@Component({
  selector: 'app-purchase-requsition-form',
  templateUrl: './purchase-requsition-form.component.html',
  styleUrls: ['./purchase-requsition-form.component.scss']
})
export class PurchaseRequsitionFormComponent implements OnInit {

  @Input() public vm: SavePurchaseMasterRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  modalRef: BsModalRef;
  public component_Title = 'Purchase Requisition';
  public isPreview: boolean = false;
  public thumbnail: any;
  public ComName: any;
  public Address: any;
  public contect: any;

  public modalOptions = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  };
  private submitted = false;

  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public accountDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'accTitle',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  // public wareHouseDropdownSettings: IDropdownSettings = {
  //   singleSelection: true,
  //   idField: 'Id',
  //   textField: 'Acc_Titel',
  //   enableCheckAll: false,
  //   selectAllText: 'Select All',
  //   unSelectAllText: 'UnSelect All',
  //   itemsShowLimit: 4,
  //   allowSearchFilter: true
  // };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  public sparePartVm: SaveItemRequest = new SaveItemRequest();
  public citemtype = 'itemtype';
  public itemTypes: any = [];

  public suppliers: any = [];
  public csuppliers = 'suppliers';
  public selectedSuppliers: any = [];
  public selectedSupplierEmail: any;

  public items: any = [];
  public citems = 'items';
  public selectedItems: any = [];

  public user: any;

  public spareParts: any = [];
  public selectedSpareParts: any = [];
  public wareHouses: Array<any> = [];
  public selectspp: any;
  public selected: boolean = false;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  name = 'cpEmail';
  id = 'id';
  checked = true;
  disabled = false;
  label = 'Toggle On/Off';
  labelledby = 'Some Other Text';

  ngOnInit() {
    this.user = this._localStorageService.get("ussr");
    this.getimage();
    debugger
    if (this.vm == undefined) {
      this.vm = new SavePurchaseMasterRequest();
      this.vm.purchaseDetail = [];
      this.vm.transactionDate = new Date();
      this.vm.requiredDate = new Date();
      this.vm.debitAcc = new ItemViewModel1();
      this.vm.supCreditAcc = new ItemViewModel1();
      this.vm.statusType = new ItemViewModel1();
      this.vm.tag = new ItemViewModel1();
      this.vm.supplier = new ItemViewModel1();
      this.vm.wareHouse = new ItemViewModel1();

      this.vm.purchaseDetail = [];
      this.spareParts = [];
      this.vm.supCreditAccEmail = new ItemViewModel1(0, "");
      this._uow.gPurchaseService.GetGPurchaseRefIdAsync().subscribe((res: any) => {
        console.log(res);
        this.vm.refId = res.code;
      }, (error) => {
        console.log(error);
      });
    } else {
      let selectedSuplier: any = [];
      let selectedSaprePartsList: any = [];
      if (this.vm.supCreditAcc != undefined && this.vm.supCreditAcc != null) {
        let sCA = new AccountDefiningModel();
        sCA.id = this.vm.supCreditAcc.id;
        sCA.accTitle = this.vm.supCreditAcc.name;
        selectedSuplier.push(sCA);
        this.selectedSuppliers = selectedSuplier;
        this.vm.supCreditAcc = new ItemViewModel1(this.vm.supCreditAcc.id, this.vm.supCreditAcc.name);
      }
      console.log('purchase detail', this.vm.purchaseDetail);
      this.vm.purchaseDetail.forEach(x => {
        let partssSelected = new SaveItemRequest();
        partssSelected.id = x.item.id;
        partssSelected.name = x.item.name;
        selectedSaprePartsList.push(partssSelected);
      });
      this.selectedSpareParts = selectedSaprePartsList;

      this.selected = true;
      this.getSpareParts(this.vm.wareHouse.id);
    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Purchase Requsition';
    }

    this.sparePartVm = new SaveItemRequest();
    this.sparePartVm.itemType = new ItemViewModel1(0, ' ');

    // this.getSpareParts();
    this.getItemTypes();
    this.getSuppliers();
    this.getWareHouses();
  }

  onChange(e) {
    debugger
    let item = this.selectspp;
    if (e == true) {
      if (this.selectedSuppliers.length > 0 && this.suppliers != undefined) {
        let findSelected = this.suppliers.find(x => x.id == this.selectedSuppliers[0].id);
        this.vm.supCreditAccEmail = new ItemViewModel1(findSelected.id, findSelected.cpEmail);
        this.vm.isEmailRequired = true;
      }
    } else {
      this.vm.supCreditAccEmail = null;
      this.vm.isEmailRequired = false;
    }
  }

  getimage() {

    this._uow.gSettingService.GetHeaderFootersDropDownAsync().subscribe((baseImage: any) => {
      console.log(baseImage);
      debugger;
      if (baseImage != undefined && baseImage !== null) {
        if (baseImage.attachment != undefined && baseImage.attachment !== null) {

          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        } else {
          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        }
      }
    }, (err) => {
      console.log(err);
    })
  }

  getItemTypes() {
    this._uow.gSettingService.GetItemTypesAsync().subscribe((res: any) => {
      this.itemTypes = res.result;
      console.log(res);
    }, (err) => this._uow.logger.log(err));
  }

  getSuppliers() {
    this._uow.gSettingService.GetGCustomersDropDownAsync(AppConsts.SUPPLIER).subscribe((res: any) => {

      this.suppliers = res.result;
      this._uow.logger.log(this.suppliers);
    }, (err) => this._uow.logger.log(err));
  }

  getWareHouses() {
    this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe(
      (res: any) => {
        debugger
        this.wareHouses = res.result;
      },
      (error) => {
        console.log(error);
      }
    );
  }


  onSelectWareHouse() {
    debugger
    this.selected = true;
    this.selectedSpareParts = [];
    this.vm.purchaseDetail = [];
    this.getSpareParts(this.vm.wareHouse.id);
  }

  getSpareParts(id) {
    debugger
    this._uow.gSettingService.GetItemsDropDownByWarehouseIdAsync(id).subscribe((res: any) => {
      debugger
      this.spareParts = res.result;
      console.log('list', res)

    }, (err) => {
      this._uow.logger.log(err);
      this.spareParts = [];
    });
  }


  getSparePartsForVendor(e) {
    debugger
    let id = null;
    let selectedSparePartsss: any = []
    this.selectedSpareParts = [];
    this.vm.purchaseDetail = [];
    if (this.selectedSuppliers.length > 0) {
      id = this.selectedSuppliers[0].id;
    }
    let idd = this.vm.wareHouse.id;
    this._uow.gSettingService.GetItemsDropDownByWarehouseAndSupplierIdAsync(id, idd).subscribe((res: any) => {
      debugger
      res.result.forEach(item => {
        if (item !== undefined) {
          let i = new PurchaseDetailModel();
          i.quantity = 1;
          i.item = new ItemViewModel1(item.id, item.name);
          i.maxQuantity = item.maxStock;
          i.maxStock = item.maxStock;
          i.minStock = item.minStock;
          i.currentStock = item.currentStock;
          i.quantity = item.maxStock - item.currentStock;
          i.itemCode = item.code;
          i.itemName = item.name;
          i.purchasePrice = item.purchasePrice;
          i.salePrice = item.salePrice;
          i.itemType = item.itemType.name;
          this.vm.purchaseDetail.push(i);

          let fsp = this.selectedSpareParts.find(x => x.id == item.id);
          if (fsp == undefined) {
            //selectedSparePartsss.push(new ItemViewModel(item.id, item.name));
            selectedSparePartsss.push({
              id: item.id,
              name: item.name
            });
          }
          //this.selectedSpareParts = selectedSparePartsss;
        }
      });
      this.selectedSpareParts = selectedSparePartsss;
      console.log(res);
    }, (error) => {
      console.log(error);
    });
  }

  onSelectSupplier(e) {
    debugger
    this.selectedSpareParts = [];
    this.vm.purchaseDetail = [];
    let item = this.suppliers.find(x => x.id === e.id);
    if (item !== undefined) {
      let i = new SavePurchaseMasterRequest();
      this.vm.supCreditAcc = new ItemViewModel1(item.id, item.accTitle);
      this.selectspp = item;
      //this.vm.FK_Sup_Cradit_Acc.Id = item.Id;
      //this.vm.FK_Sup_Cradit_Acc.Name = item.Acc_Titel;
    }
  }
  // spare parts
  onSelectSparePart(e) {

    console.log(e);
    let item = this.spareParts.find(x => x.id === e.id);
    if (item !== undefined) {
      let i = new PurchaseDetailModel();
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.maxQuantity = item.maxStock;
      i.maxStock = item.maxStock;
      i.minStock = item.minStock;
      i.currentStock = item.currentStock;
      i.availabelQuantity = item.currentStock;
      i.quantity = item.maxStock - item.currentStock;
      if (item.currentStock > item.maxStock) {
        i.quantity = 0;
      }
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.itemType = item.itemType.name;

      this.vm.purchaseDetail.push(i);
      let fsp = this.selectedSpareParts.find(x => x.id == item.id);
      if (fsp == undefined) {
        this.selectedSpareParts.push(new ItemViewModel1(item.id, item.name));
      }
    }

    console.log(this.selectedSpareParts);
  }

  onDeSelectSparePart(e) {
    debugger
    let i = this.vm.purchaseDetail.find(x => x.item.id === e.id);

    if (i !== undefined) {
      this.vm.purchaseDetail.splice(this.vm.purchaseDetail.indexOf(i), 1);
    }

  }

  onRemoveFromDetailList(e) {
    console.log(e);
    let i = this.vm.purchaseDetail.find(x => x.item.id === e.item.id);
    if (i !== undefined) {
      this.vm.purchaseDetail.splice(this.vm.purchaseDetail.indexOf(i), 1);
    }
    let s = this.selectedSpareParts.find(x => x.id === e.id);
    if (s !== undefined) {
      this.selectedSpareParts.splice(this.selectedSpareParts.indexOf(s), 1);
    }
  }

  openPreview(content) {
    debugger
    this.modalRef = this._uow.modalServiceEx.show(content);
    this.modalRef.setClass('modal-lg');
    this.isPreview = true;
  }

  openModalLg(template: TemplateRef<any>, itemtype?) {
    this.sparePartVm = new SaveItemRequest();
    if (itemtype == 1) {
      let i = this.itemTypes.find(x => x.name == 'Spare-Parts');
      console.log(i)
      this.sparePartVm.itemType = new ItemViewModel1(i.id, i.name);
    }
    if (itemtype == 2) {
      let i = this.itemTypes.find(x => x.name == 'Services');
      this.sparePartVm.itemType = new ItemViewModel1(i.id, i.name);
    }
    this.openModal(template);
    this.modalRef.setClass('modal-lg');
  }

  // exteral coponents
  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._uow.modalServiceEx.show(template);//this._modalService.show(template, this.modalOptions);
    }
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }
  compareFn(optionOne, optionTwo): boolean {
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }

  public itemType = new ItemViewModel1();
  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {

    if (model !== undefined) {
      this.sparePartVm = model;
    } else {
      this.sparePartVm = undefined;
    }
    this.openModal(template, 1);
    this.modalRef.setClass('modal-xl');
  }
  openSaveOrUpdateModelForItemType(template: TemplateRef<any>, model?, itemType?) {
    this.itemType = this.itemTypes[itemType];
    this.sparePartVm.itemType = new ItemViewModel1(this.itemType.id, this.itemType.name);
    // this.sparePartVm.FK_G_ItemType_Id = new ItemViewModel(this.itemType.Id, this.itemType.Name);
    console.log(this.itemTypes);
    this.openSaveOrUpdateModel(template, model);
  }

  saveOrUpdate(event: any) {
    event.preventDefault();
    debugger
    if (this.selectedSuppliers.length > 0) {
      this.vm.supCreditAcc = new ItemViewModel1(this.selectedSuppliers[0].id, this.selectedSuppliers[0].accTitle);
      this.vm.supCreditAccEmail = new ItemViewModel1(this.selectedSuppliers[0].id, this.selectedSuppliers[0].cpEmail);
    }
    this.vm.statusType = new ItemViewModel1(E_G_EPSStatusType.Purchase_Requisition)
    this.onChange(true);
    // this._jq.showSpinner(true);
    this.spinner.show();
    this._uow.gPurchaseService
      //.Post(this.vm)
      .SaveGPurchaseAsync(this.vm)
      .toPromise().then((res: any) => {
        debugger
        console.log(res);
        this.submitted = true;
        this.bsmRef.hide();
        this.vm.isEmailRequired = true;
        // this._uow.dataService.setValue(true);
        //this.modalRef.hide();
        this.onSubmitted.emit(this.submitted);
        this.spinner.hide();
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        );
      })
      .catch((error) => {
        debugger
        this.spinner.hide();
        console.log(error);
        Swal.fire(
          'Failure!',
          'Purchase Not Updated!',
          'error'
        )
        // console.log(`Promise rejected with ${JSON.stringify(error)}`);
        // this.onSubmitted.emit(this.submitted);

        // this._jq.showSpinner();
      });
  }

  navigateClick() {
    this.isPreview = false;
    this.modalRef.hide();
  }

  // external components
  onItemSubmitted(e, mf) {
    this._uow.logger.log(e);
    if (e === true) {

    }
  }

  closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }


}
